import { __assign, __rest } from "tslib";
// DS2.2
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { getIconSizeForButtonSize } from '../helpers';
import s from './GhostButton.scss';
var GhostButton = function (_a) {
    var size = _a.size, variant = _a.variant, fillContainerWidth = _a.fillContainerWidth, className = _a.className, children = _a.children, IconComponent = _a.icon, PostFixIconComponent = _a.postfixIcon, loading = _a.loading, props = __rest(_a, ["size", "variant", "fillContainerWidth", "className", "children", "icon", "postfixIcon", "loading"]);
    var iconSize = getIconSizeForButtonSize(size);
    return (React.createElement(PlainButtonOrLink, __assign({ className: classnames(className, s['root'], s["variant-".concat(variant)], s["size-".concat(size)], fillContainerWidth && s['fill-container-width'], props.disabled && s['disabled'], loading && s['loading']) }, props),
        IconComponent && (React.createElement(IconComponent, { className: s['icon'], size: iconSize, disableDefaultColors: true })),
        React.createElement("span", { className: s['content'] }, children),
        PostFixIconComponent && (React.createElement(PostFixIconComponent, { className: s['icon'], size: iconSize, disableDefaultColors: true }))));
};
GhostButton.displayName = 'GhostButton';
export default GhostButton;
//# sourceMappingURL=GhostButton.js.map